import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Pages from './pages/index';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from './context/authContext';
import Signup from './components/Login/signup';
import ForgotPassword from './components/ForgotPassword';
import VerifyOtp from './pages/verifyOtp';
import ChangePassword from './components/ForgotPassword/ChangePassword';
import Successful from './components/ForgotPassword/Successful';
import OtpConfirm from './components/ForgotPassword/OtpConfirm';
import Layout from './components/Layout';
import ResearchProjectBlock from './components/ResearchProjectBlock';
import PlanSection from './components/PlanSection';
import Chat from './pages/chat';
import EditAgent from './pages/editAgent';
import CreateWorkflow from './pages/createWorkflow';
import AgentDetails from './pages/agentDetails';

const Router = () => {
  function PublicRoute({ children, redirectTo, isLoggedIn }) {
    return isLoggedIn ? <Navigate to={redirectTo} replace /> : children;
  }

  function PrivateRoute({ children, redirectTo, isLoggedIn }) {
    return isLoggedIn ? children : <Navigate to={redirectTo} replace />;
  }

  const { isLoggedIn } = useContextHook(AuthContext, ['isLoggedIn']);
  const appHome = '/dashboard';
  const authHome = '/login';
// testing
  return (
    <Routes>
      <Route
        path="/"
        element={isLoggedIn ? <Navigate to={appHome} replace /> : <Navigate to={authHome} replace />}
      />

      <Route
        path="/:view"
        element={
          <PrivateRoute redirectTo={authHome} isLoggedIn={isLoggedIn}>
            <Pages />
          </PrivateRoute>
        }
      />

      <Route
        path="/chat/:id"
        element={
          <PrivateRoute redirectTo={authHome} isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <Chat />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/edit-agent/:id"
        element={
          <PrivateRoute redirectTo={authHome} isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <EditAgent />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/workflows/:id"
        element={
          <PrivateRoute redirectTo={authHome} isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <CreateWorkflow />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/project/:id"
        element={
          <PrivateRoute redirectTo={authHome} isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <ResearchProjectBlock />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/agents/:id"
        element={
          <PrivateRoute redirectTo={authHome} isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <AgentDetails />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/login"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={appHome}>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/sign-up"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={appHome}>
            <Signup />
          </PublicRoute>
        }
      />

      <Route
        path="/forgot-password"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={appHome}>
            <ForgotPassword />
          </PublicRoute>
        }
      />

      <Route
        path="/verify-otp"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={appHome}>
            <VerifyOtp />
          </PublicRoute>
        }
      />

      <Route
        path="/verify-email"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={appHome}>
            <OtpConfirm />
          </PublicRoute>
        }
      />

      <Route
        path="/change-password"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={appHome}>
            <ChangePassword />
          </PublicRoute>
        }
      />

      <Route
        path="/successful"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={appHome}>
            <Successful />
          </PublicRoute>
        }
      />

      <Route
        path="/upgrade-plan"
        element={
          <PrivateRoute redirectTo={authHome} isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <PlanSection />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="*"
        element={isLoggedIn ? <Navigate to={appHome} replace /> : <Navigate to={authHome} replace />}
      />
    </Routes>
  );
};

export default Router;
